/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Pages_Update_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update pages add-on." |
*
* @param {Sub_Addons_Toast_Pages_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_pages_update_error = /** @type {((inputs?: Sub_Addons_Toast_Pages_Update_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Pages_Update_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seiten-Add-on konnte nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Failed to update pages add-on.")
});